interface RootState {
	brand: {
		enableMobileQuickDeposit: boolean;
		enableQuickDepositOnHeader: boolean;
	};
}
const NS = 'brand';
const selectGlobalQuickDepositEnabled = (state: RootState) =>
	state[NS].enableMobileQuickDeposit && state[NS].enableQuickDepositOnHeader;
export default selectGlobalQuickDepositEnabled;
